/**
 * Formato CUIT/CUIL argentino: XX-XXXXXXXX-X (11 dígitos).
 */

export function stripCuitCuilDigits(value) {
  return String(value || '').replace(/\D/g, '').slice(0, 11);
}

export function formatCuitCuilDisplay(value) {
  const d = stripCuitCuilDigits(value);
  if (!d) return '';
  if (d.length <= 2) return d;
  if (d.length <= 10) return `${d.slice(0, 2)}-${d.slice(2)}`;
  return `${d.slice(0, 2)}-${d.slice(2, 10)}-${d.slice(10)}`;
}

/** Handler para v-model / @input en text fields. */
export function applyCuitCuilInput(value) {
  return formatCuitCuilDisplay(value);
}
